import * as React from "react";

import { logAction, useRelodeReducer, useSnackMiddleware } from "@relode/core";
import { JobActions, useJobActions } from "./jobActions";
import { useJobHandlers } from "./jobHandlers";
import { useJobErrorHandlers } from "./jobErrorHandlers";
import { jobReducer } from "./jobReducer";
import { initialJobState, JobState } from "./jobState";

type IJobContext = {
    state: JobState;
    actions: JobActions;
};

export const JobContext = React.createContext<IJobContext>(undefined);

export const useJobContext = () => {
    const context = React.useContext(JobContext);
    if (!context) {
        throw new Error(
            "useJobContext must be used within an appropriate provider"
        );
    }
    return context;
};

export const JobProvider = (props: { children: React.ReactNode }) => {
    const [state, dispatch] = useRelodeReducer(jobReducer, initialJobState, [
        useSnackMiddleware(),
        logAction,
    ]);

    const actions = useJobActions(state, dispatch);
    useJobHandlers(state, actions);
    useJobErrorHandlers(state, actions);

    const value = {
        state,
        actions,
    } as IJobContext;
    return <JobContext.Provider value={value} {...props} />;
};
